import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { defaultSYS4090_R01Dto, SYS4090_R01Dto } from "./Dto_SYS4090_R01";

export interface SYS4090_R01Filter {
	bankCd: string;
	acctType: string;
	includeDue: string;
	// baseDate: DateRange | undefined;
	baseDate: Date | undefined;
}

export interface Store_SYS4090_R01 {

    
	SYS4090_R01Filter: SYS4090_R01Filter;
	SYS4090_R01PastFilter: SYS4090_R01Filter;
	setSYS4090_R01Filter: (filter: Partial<SYS4090_R01Filter>) => void;
	setSYS4090_R01PastFilter: (filter: Partial<SYS4090_R01Filter>) => void;

    SYS4090_R01List: SYS4090_R01Dto[];
    setSYS4090_R01List: (list: SYS4090_R01Dto[]) => void;

    selectedSYS4090_R01: SYS4090_R01Dto | undefined;
    setSelectedSYS4090_R01: (bank: SYS4090_R01Dto | undefined) => void;
	initSelectedSYS4090_R01: () => void;

    editSYS4090_R01: SYS4090_R01Dto | null;
    setEditSYS4090_R01: (data: SYS4090_R01Dto | null) => void;

    columnState: ColumnState[] | null;		setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;
	

	initData: () => void;
}

export const defaultSYS4090_R01Filter: SYS4090_R01Filter = {

	bankCd: '',
	acctType: '',
	includeDue: 'N',
	// baseDate: { from: new Date(new Date().setMonth(new Date().getMonth() - 1)), to: new Date() },
	baseDate: new Date(),
}

export const useSYS4090_R01Store = create<Store_SYS4090_R01>((set) => ({
    
    SYS4090_R01Filter: defaultSYS4090_R01Filter,
	SYS4090_R01PastFilter: defaultSYS4090_R01Filter,
    setSYS4090_R01Filter: (cond) => set((state) => ({
		...state,
		SYS4090_R01Filter: { ...state.SYS4090_R01Filter, ...cond }
	})),
    setSYS4090_R01PastFilter: (cond) => set((state) => ({
		...state,
		SYS4090_R01PastFilter: { ...state.SYS4090_R01PastFilter, ...cond }
	})),

    SYS4090_R01List: [],
    setSYS4090_R01List: (list) => set({ SYS4090_R01List: list }),

    selectedSYS4090_R01: undefined,
    setSelectedSYS4090_R01: (bank) => set((state) => {
		
		return { ...state, selectedSYS4090_R01: bank };
    }),
	initSelectedSYS4090_R01: () => set({ selectedSYS4090_R01: undefined, editSYS4090_R01: null }),

    editSYS4090_R01: defaultSYS4090_R01Dto,
    setEditSYS4090_R01: (data) => set((state) => {
		// console.log(data);
		let editSYS4090_R01 = defaultSYS4090_R01Dto;
		if (data) {
			editSYS4090_R01 = {
				...data
			}
		}
		return { ...state, editSYS4090_R01: editSYS4090_R01 };
    }),

	columnState: null,		setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set({
		SYS4090_R01Filter: defaultSYS4090_R01Filter,
		SYS4090_R01PastFilter: defaultSYS4090_R01Filter,
		SYS4090_R01List: [],
		selectedSYS4090_R01: undefined,
		editSYS4090_R01: defaultSYS4090_R01Dto,
		allCount: 0,
		scrollTop: null,
	}),

}));